import axios from 'axios'
import { config } from 'config'
import { API } from 'constants/apiEndPoints'
import { EVENTS } from 'constants/events'
import { useEffect, useState } from 'react'
import { emitCustomEvent } from 'react-custom-events'

const INIT_COUNTRY_ALLOWANCE = {
  isAllowed: true,
  countryISOCode: '',
  timeOffsetMs: 0,
}

export const checkCountryAllowance = async (configObj?: {
  noEvent: boolean
}): Promise<typeof INIT_COUNTRY_ALLOWANCE> => {
  const { noEvent } = configObj || { noEvent: false }
  const overrideAuth = ['dev'].includes(config.BASE_BRANCH)
  const { data } = await axios.post(API.AUTH_IP_CHECK)
  const payload = {
    isAllowed: overrideAuth || data?.allowed,
    countryISOCode: data?.countryISOCode,
    timeOffsetMs: 0,
  }
  !noEvent && emitCustomEvent(EVENTS.USER_COUNTRY_ALLOWANCE, payload)
  return payload
}

export const useCountryAllowance = (triggerArray: any[]) => {
  const [ipAllowance, setIpAllowance] = useState(INIT_COUNTRY_ALLOWANCE)

  const updateCountryAllowance = () =>
    checkCountryAllowance({ noEvent: true }).then((payload) => {
      setIpAllowance(payload)
    })

  useEffect(() => {
    updateCountryAllowance()
  }, [])

  return ipAllowance
}
